export const addresses = {
  tokenGate: "0xEDE1a69DB77c4CBa8d15F9170568959a56Ce9c05",
};
